<template>
  <div class="wrap"
       v-show="show"
       :class="{'fadein': show, 'fadeout': !show}"
       :style="{left,top,bottom,right,width,fontSize}">
    <div class="tips-text">
      <div v-html="text"
           v-if="text">{{ text }}</div>
      <div id="toast-template"></div>
      <div class="assist"
           v-show="type === 2">{{ assist }}</div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.wrap {
	position: absolute;
	background-color: #5d6265;
	padding: 10px 15px;
	border-radius: 3px;
	color: #fff;
	transform: translate(-50%, -50%);
	box-shadow: 1px 1px 1px 1px rgba(204, 204, 204, 0.2);
	font-size: 12px;
	display: flex;
	z-index: 10019;
	justify-content: center;
	border: 1px solid #8a8e92;
	opacity: 0.95;
}

.tips-text {
  /* margin: 0 0 0 0.85em; */
  font-size: 1em;
  color: #fff;
}

.assist {
  font-size: 0.8em;
  margin: 0.3em 0 0 0;
  color: #fff;
}

.fadein {
  animation: animate_in 0.4s;
}

.fadeout {
  animation: animate_out 0.4s;
  opacity: 0;
}

@keyframes animate_in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes animate_out {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
